import { render } from "./localization-index.vue?vue&type=template&id=27f5e128"
import script from "./localization-index.vue?vue&type=script&lang=js"
export * from "./localization-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__